import {Component, DoCheck, Input, OnInit} from '@angular/core';
import {EmpleadoModel} from '../../CoreModule/models/empleado.model';
import {EmpleadoSemanaModel} from '../models/empleado.semana.model';
import {Indicadores} from './tienda.component';
import {PlanAccionModel} from '../models/plan.accion.model';
import {SemanaModel} from '../models/semana.model';
import {PlanAccionServices} from '../services/plan.accion.services';

@Component({
  selector: 'emple-indi',
  templateUrl: '../templates/tiendas/indicadores.empleados.template.html'
})
export class IndicadoresEmpleadosComponent implements DoCheck{

  @Input()
  empleado: EmpleadoModel;
  @Input()
  malla: EmpleadoSemanaModel;

  @Input()
  indTienda:Indicadores;



  classTicketProm:any;
  classArticulosTicket:any;
  classTicketDia:any;
  classVentaDia:any;


  ngDoCheck(): void {
    if(this.empleado.indicadores.ticketPromedio >= this.indTienda.ticketPromedio)
      this.classTicketProm = ["col-6", "text-center", "cumplido"];

    else
      this.classTicketProm = ["col-6", "text-center", "noCumplido"];

    if(this.empleado.indicadores.articulosTicket >= this.indTienda.articulosTicket)
      this.classArticulosTicket = ["col-6", "text-center", "cumplido"];

    else
      this.classArticulosTicket = ["col-6", "text-center", "noCumplido"];

    if(this.empleado.indicadores.ticketxDia >= this.indTienda.ticketxDia)
      this.classTicketDia = ["col-6", "text-center", "cumplido"];

    else
      this.classTicketDia = ["col-6", "text-center", "noCumplido"];

    if(this.empleado.indicadores.ventaxDia >= this.indTienda.ventaxDia)
      this.classVentaDia = ["col-6", "text-center", "cumplido"];

    else
      this.classVentaDia = ["col-6", "text-center", "noCumplido"];

    //console.log(`empleado ${this.empleado.nombre}, indicador a mejorar ${this.empleado.indMejorar}`);
  }


}

